// extracted by mini-css-extract-plugin
module.exports = {"container":"_2n0WB4","image":"_2IKtgf","loader":"pG86Or","title":"_6iGHWY","brand":"qpqrae","upchargePrice":"_33QXKo","shine-lines":"CJBzUF"};